import gsap from 'gsap'
import { startReveal } from '../components/reveal'
import { prefersReducedMotion } from '../utils/motion'

export function initialTransition() {
	if (prefersReducedMotion()) {
		document.body.classList.remove('page-transition--in-progress')
		gsap.set('.page-transition', { autoAlpha: 0 })
		startReveal()
		return
	}

	let initialTimeline = gsap.timeline({
		onStart: () => {
			document.body.classList.add('page-transition--in-progress')
		},
		onComplete: () => {
			document.body.classList.remove('page-transition--in-progress')
			startReveal()
		},
	})
	initialTimeline.to('.page-transition', {
		autoAlpha: 0,
		duration: 0.6,
		ease: 'sine.inOut',
	})
}
